export enum PropertySituation {
  BUILT = 'EDIFICADO',
  UNDER_CONSTRUCTION = 'EM_CONSTRUCAO',
  NO_BUILDING = 'SEM_EDIFICACAO',
}
